import type { ColumnDef } from '@tanstack/table-core';
import { DataTableViewOptions } from '@/components/DataTable/Table/DataTableViewOptions';

/**
 * 列の表示/非表示を切り替える DataTableViewOptions を右端に置くアクション列。
 * 契約系テーブル（一覧・アラート等）で共有するためジェネリックにしている。
 */
export function actionsColumn<TData>(): ColumnDef<TData> {
  return {
    id: 'actions',
    enableSorting: false,
    enableHiding: false,
    header: ({
      table
    }) => <div className="flex justify-end pr-2">
        <DataTableViewOptions table={table} />
      </div>,
    cell: () => null
  };
}